// extracted by mini-css-extract-plugin
module.exports = {"container":"Header-module--container--1n00k","image":"Header-module--image--1m5vP","logo":"Header-module--logo--10MlI","imgContainer":"Header-module--imgContainer--2h8fj"};